import { HttpService } from "./http-service";
import { KyClient } from "./ky-client";
import { TokenInterceptor } from './token-interceptor';

const headers = {
  "Content-Type": "application/json",
};

export const host = import.meta.env.VITE_API_URL;
export const tokenInterceptor = new TokenInterceptor();

export const httpService = new HttpService(
  new KyClient({ prefixUrl: host, headers })
);

export {
  InternalServerException,
  ResourceNotFoundException,
} from "./exceptions";

export { AjaxError } from "./ajax-error";
